import { onDestroy } from 'svelte';
import { connectCostsStream } from './cost-stream';
import type { CostsPeriod } from './costs-period';

interface LiveCostsOpts {
  /** O período em tela, lido a cada aviso — não capturado uma vez. */
  period: () => CostsPeriod;
  reload: () => void;
  onLive?: (live: boolean) => void;
  /** Falso enquanto a tela está encoberta por outra — lista com detalhe aberto. */
  enabled?: () => boolean;
}

/**
 * Mantém a tela assinada no aviso de gasto novo enquanto o período em tela
 * termina hoje. Período fechado não recebe gasto: assinar seria manter uma
 * conexão aberta para um número que não muda mais.
 *
 * Lista e detalhe assinam pelo mesmo caminho — o detalhe ficou de fora na
 * primeira versão e quem abria um cliente lia número parado até dar F5.
 */
export function liveCosts(opts: LiveCostsOpts): void {
  let close: (() => void) | null = null;

  const disconnect = (): void => {
    close?.();
    close = null;
  };

  $effect(() => {
    if (opts.enabled && !opts.enabled()) {
      disconnect();
      return;
    }
    if (!opts.period().endsToday) {
      disconnect();
      opts.onLive?.(false);
      return;
    }
    if (close) return;
    close = connectCostsStream({
      onUpdated: () => opts.reload(),
      onOpen: () => opts.onLive?.(true),
      onReopen: () => opts.reload(),
      onError: () => opts.onLive?.(false),
    });
  });

  onDestroy(disconnect);
}
